import searcherMixin from "../../mixins/searcherMixin";
import prependCustomIcons from "../../../../utils/mixins/prependCustomIcons";
import replaceArrows from "../../../../utils/mixins/replaceArrows";
import { SET_SEARCH_ORIGIN } from "../../../../store/search/mutation-types";
import { ucfirst } from "../../../../utils/strings";

export default {
  mixins: [searcherMixin, prependCustomIcons, replaceArrows],
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: () => false
    },
    searchType: {
      type: Number,
      required: false,
      default: () => 0
    },
    isFlat: {
      type: Boolean,
      required: false,
      default: () => false
    },
    isDestinySearch: {
      type: Boolean,
      required: false,
      default: () => false
    },
    activeTab: {
      type: Number,
      required: false,
      default: () => 0
    }
  },
  data: () => ({
    showDialog: false,
    today: new Date().toISOString(),
    attrs: "",
    value: null,
    on: "",
    locale: window.appLocale,
    ucfirst,
  }),
  watch: {
    value: function (val) {
      this.form.date.value = val;

      this.handleSelectDate(val);
    },
    searchType() {
      this.$nextTick(this.init);
    }
  },
  methods: {
    dateFormat(classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() < new Date();
      }
      return classes;
    },
    allowedDates: val => new Date(val) >= new Date(),
    init() {
      const selectTravellers = this.$el.querySelector(
        ".avm-text-field--travellers .v-input__slot"
      );
      if (selectTravellers) {
        selectTravellers.addEventListener("click", () => {
          this.showDialog = true;
          this.form.showTravellersMenu = true;
        });
      }
      const selectDate = this.$el.querySelector(
        ".avm-text-field--date .v-input__slot"
      );
      if (selectDate) {
        selectDate.addEventListener("click", () => {
          this.form.date.showMenu = true;
        });
      } else {
        this.form.date.showMenu = false;
      }
    }
  },
  mounted() {
    this.init();
    if (! this.isFlat && ! this.isDestinySearch) {
      if (this.originsOptions.length && this.origin && ! this.originsOptions.find(({ code }) => code === this.origin.code)) {
        this.$store.commit(SET_SEARCH_ORIGIN, null);
      }
    }
  },
  computed: {}
};
